import React from 'react';
import { PageShell } from './Page';
import { PersistentPageContext } from './PersistentPageContext';

export const wrapPageElement = ({ element, props }: any) => {
    if (
        !props.pageContext?.sharedLayout ||
        !props.data?.kontentItemLayoutMasterPage
    )
        return element;
    return (
        <PersistentPageContext.Provider value={true}>
            <PageShell {...props}>{element}</PageShell>
        </PersistentPageContext.Provider>
    );
};
